import taxExemptionIcon from "../../assets/images/taxExemptionIcon.png";
import prophylacticVaccinesIcon from "../../assets/images/prophylactic-vaccines-icon.png";
import mrnaNewsIcon from "../../assets/images/mrnaNewsIcon.png";

export const newsData = {
    newsCards: [
        {
            title: "Tax Exemption Certificate Submission",
            headline: "Tax Exemption Certificate Submission: Submit your tax exemption certificates",
            link: "https://taxform.modernatx.com/",
            label: "Tax Exemption Certificate Submission",
            imageUrl: taxExemptionIcon
        },
        {
            title: "mRNA News Component",
            headline: "For more information about Moderna’s mRNA platform",
            link: "https://www.modernatx.com/en-US/power-of-mrna/science-of-mrna",
            label: "mRNA News",
            imageUrl: mrnaNewsIcon
        },
        {
            title: "News on current Moderna COVID-19 Vaccines",
            headline: "For more information on the current Moderna COVID-19 vaccines",
            link: "https://eua.modernatx.com/",
            label: "Learn COVID-19 Vaccines",
            imageUrl: prophylacticVaccinesIcon
        }
    ]
};
